// @ts-nocheck
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import notify from '../utils/toast';
import { useI18n } from '../context/I18nContext';
import { useAuth } from '../context/AuthContext';
import ActionButtons from '../components/ActionButtons';
import AppModal from '../components/AppModal';

export default function Materials() {
    const { t, lang } = useI18n();
    const { hasRole, can } = useAuth();
    const canEdit = can('materials.create') || can('materials.edit') || can('materials.manage');

    const [materials, setMaterials] = useState([]);
    const [categories, setCategories] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [summary, setSummary] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState('stock');
    const [filterCat, setFilterCat] = useState('');

    const [showMat, setShowMat] = useState(false);
    const [showTx, setShowTx] = useState(false);
    const [showSup, setShowSup] = useState(false);
    const [showCat, setShowCat] = useState(false);

    const closeMatModal = () => {
        setShowMat(false);
        setMatForm({
            name: '', code: '', category_id: '', unit: 'bag', min_stock: 0, current_stock: 0, unit_cost: 0,
            inventory_account_id: '', expense_account_id: '', purchase_account_id: '',
        });
    };
    const closeTxModal = () => {
        setShowTx(false);
        setTxForm({
            material_id: '', type: 'purchase', quantity: '', unit_cost: '', project_id: '', supplier_id: '',
            transaction_date: new Date().toISOString().slice(0, 10), notes: '', post_to_accounts: true,
        });
    };
    const closeSupModal = () => {
        setShowSup(false);
        setSupForm({ name: '', contact_person: '', phone: '', address: '' });
    };
    const closeCatModal = () => {
        setShowCat(false);
        setCatForm({
            name: '', code: '', description: '',
            inventory_account_id: '', expense_account_id: '', purchase_account_id: '', sort_order: 0,
        });
    };




    const [matForm, setMatForm] = useState({
        name: '', code: '', category_id: '', unit: 'bag', min_stock: 0, current_stock: 0, unit_cost: 0,
        inventory_account_id: '', expense_account_id: '', purchase_account_id: '',
    });
    const [txForm, setTxForm] = useState({
        material_id: '', type: 'purchase', quantity: '', unit_cost: '', project_id: '', supplier_id: '',
        transaction_date: new Date().toISOString().slice(0, 10), notes: '', post_to_accounts: true,
    });
    const [supForm, setSupForm] = useState({ name: '', contact_person: '', phone: '', address: '' });
    const [catForm, setCatForm] = useState({
        name: '', code: '', description: '',
        inventory_account_id: '', expense_account_id: '', purchase_account_id: '', sort_order: 0,
    });

    const load = () => {
        setLoading(true);
        Promise.all([
            api.get('/materials', { params: filterCat ? { category_id: filterCat } : {} }),
            api.get('/materials/categories').catch(() => ({ data: { data: [] } })),
            api.get('/materials/suppliers'),
            api.get('/materials/stock-summary'),
            api.get('/materials/transactions'),
            api.get('/projects').catch(() => ({ data: { data: [] } })),
            api.get('/accounts/chart').catch(() => ({ data: { data: [] } })),
        ]).then(([m, c, s, sum, tx, p, a]) => {
            setMaterials(m.data.data);
            setCategories(c.data.data || []);
            setSuppliers(s.data.data);
            setSummary(sum.data.data);
            setTransactions(tx.data.data);
            setProjects(p.data.data || []);
            setAccounts(a.data.data || []);
        }).finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, [filterCat]);

    const createMaterial = async (e) => {
        e.preventDefault();
        try {
            const body = {
                ...matForm,
                category_id: matForm.category_id ? Number(matForm.category_id) : null,
                min_stock: Number(matForm.min_stock),
                current_stock: Number(matForm.current_stock),
                unit_cost: Number(matForm.unit_cost),
                inventory_account_id: matForm.inventory_account_id ? Number(matForm.inventory_account_id) : null,
                expense_account_id: matForm.expense_account_id ? Number(matForm.expense_account_id) : null,
                purchase_account_id: matForm.purchase_account_id ? Number(matForm.purchase_account_id) : null,
            };
            await api.post('/materials', body);
            closeMatModal();
            load();
        } catch (err) {
            notify.apiError(err);
        }
    };

    const createTx = async (e) => {
        e.preventDefault();
        try {
            await api.post('/materials/transactions', {
                ...txForm,
                quantity: Number(txForm.quantity),
                unit_cost: Number(txForm.unit_cost || 0),
                project_id: txForm.project_id || null,
                supplier_id: txForm.supplier_id || null,
                post_to_accounts: !!txForm.post_to_accounts,
            });
            closeTxModal();
            load();
        } catch (err) {
            notify.apiError(err);
        }
    };

    const createSupplier = async (e) => {
        e.preventDefault();
        try {
            await api.post('/materials/suppliers', supForm);
            closeSupModal();
            load();
        } catch (err) {
            notify.apiError(err);
        }
    };

    const createCategory = async (e) => {
        e.preventDefault();
        try {
            await api.post('/materials/categories', {
                ...catForm,
                inventory_account_id: catForm.inventory_account_id ? Number(catForm.inventory_account_id) : null,
                expense_account_id: catForm.expense_account_id ? Number(catForm.expense_account_id) : null,
                purchase_account_id: catForm.purchase_account_id ? Number(catForm.purchase_account_id) : null,
                sort_order: Number(catForm.sort_order || 0),
            });
            closeCatModal();
            setCatForm({ name: '', code: '', description: '', inventory_account_id: '', expense_account_id: '', purchase_account_id: '', sort_order: 0 });
            load();
        } catch (err) {
            notify.apiError(err);
        }
    };

    const onCategoryPick = (categoryId) => {
        const cat = categories.find((c) => String(c.id) === String(categoryId));
        setMatForm((f) => ({
            ...f,
            category_id: categoryId,
            inventory_account_id: cat?.inventory_account_id || f.inventory_account_id || '',
            expense_account_id: cat?.expense_account_id || f.expense_account_id || '',
            purchase_account_id: cat?.purchase_account_id || f.purchase_account_id || '',
        }));
    };

    const accLabel = (id) => {
        const a = accounts.find((x) => x.id === id);
        return a ? `${a.code} — ${a.name}` : '—';
    };

    if (loading && !materials.length) {
        return <div className="text-center py-5"><div className="spinner-border text-success" /></div>;
    }

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                <div>
                    <h4 className="mb-1">{t('inventoryMaterials')}</h4>
                    <p className="text-muted mb-0">
                        {t('materialsPageDesc')}
                    </p>
                </div>
                {canEdit && (
                    <div className="d-flex gap-2 flex-wrap">
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => setShowCat(true)}>+ Category</button>
                        <button className="btn btn-outline-primary btn-sm" onClick={() => setShowSup(true)}>+ Supplier</button>
                        <button className="btn btn-outline-success btn-sm" onClick={() => setShowMat(true)}>+ Item</button>
                        <button className="btn btn-primary btn-sm" onClick={() => setShowTx(true)}>+ Transaction</button>
                    </div>
                )}
            </div>

            {summary && (
                <div className="row g-3 mb-3">
                    <div className="col-md-3"><div className="card stat-card"><div className="card-body"><div className="text-muted small">Items</div><div className="fs-5 fw-bold">{summary.totalItems}</div></div></div></div>
                    <div className="col-md-3"><div className="card stat-card"><div className="card-body"><div className="text-muted small">Low stock</div><div className="fs-5 fw-bold text-danger">{summary.lowStock}</div></div></div></div>
                    <div className="col-md-3"><div className="card stat-card"><div className="card-body"><div className="text-muted small">Stock value</div><div className="fs-5 fw-bold">৳ {Number(summary.stockValue || 0).toLocaleString()}</div></div></div></div>
                    <div className="col-md-3"><div className="card stat-card"><div className="card-body"><div className="text-muted small">Categories</div><div className="fs-5 fw-bold">{categories.length}</div></div></div></div>
                </div>
            )}

            <div className="btn-group mb-3">
                <button type="button" className={`btn btn-sm ${tab === 'stock' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab('stock')}>Stock</button>
                <button type="button" className={`btn btn-sm ${tab === 'categories' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab('categories')}>Categories</button>
                <button type="button" className={`btn btn-sm ${tab === 'tx' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab('tx')}>Transactions</button>
                <button type="button" className={`btn btn-sm ${tab === 'suppliers' ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab('suppliers')}>Suppliers</button>
            </div>

            {tab === 'stock' && (
                <>
                    <div className="mb-2">
                        <select className="form-select form-select-sm" style={{ maxWidth: 260 }} value={filterCat} onChange={(e) => setFilterCat(e.target.value)}>
                            <option value="">All categories</option>
                            {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                        </select>
                    </div>
                    <div className="card table-card">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Code</th><th>Name</th><th>Category</th><th>Unit</th>
                                        <th className="text-end">Stock</th><th className="text-end">Cost</th><th className="text-end">Value</th>
                                        <th>Inventory A/C</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {materials.map((m) => (
                                        <tr key={m.id} className={parseFloat(m.current_stock) <= parseFloat(m.min_stock) ? 'table-warning' : ''}>
                                            <td><code>{m.code}</code></td>
                                            <td>{m.name}</td>
                                            <td>{m.inventoryCategory?.name || m.category || '—'}</td>
                                            <td>{m.unit}</td>
                                            <td className="text-end">{m.current_stock}</td>
                                            <td className="text-end">{Number(m.unit_cost).toLocaleString()}</td>
                                            <td className="text-end">{(parseFloat(m.current_stock) * parseFloat(m.unit_cost)).toLocaleString()}</td>
                                            <td className="small">{m.inventoryAccount ? `${m.inventoryAccount.code}` : (m.inventoryCategory?.inventoryAccount?.code || '—')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}

            {tab === 'categories' && (
                <div className="card table-card">
                    <div className="table-responsive">
                        <table className="table mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Code</th><th>Name</th>
                                    <th>Inventory A/C</th><th>Expense A/C</th><th>Purchase/Payable A/C</th>
                                </tr>
                            </thead>
                            <tbody>
                                {categories.map((c) => (
                                    <tr key={c.id}>
                                        <td><code>{c.code}</code></td>
                                        <td>{c.name}</td>
                                        <td className="small">{c.inventoryAccount ? `${c.inventoryAccount.code} — ${c.inventoryAccount.name}` : '—'}</td>
                                        <td className="small">{c.expenseAccount ? `${c.expenseAccount.code} — ${c.expenseAccount.name}` : '—'}</td>
                                        <td className="small">{c.purchaseAccount ? `${c.purchaseAccount.code} — ${c.purchaseAccount.name}` : '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="card-body small text-muted">
                        Purchase posts: Dr Inventory A/C · Cr Purchase/Payable A/C. Issue posts: Dr Expense A/C · Cr Inventory A/C.
                    </div>
                </div>
            )}

            {tab === 'tx' && (
                <div className="card table-card">
                    <div className="table-responsive">
                        <table className="table table-sm mb-0">
                            <thead className="table-light"><tr><th>Date</th><th>Type</th><th>Item</th><th>Qty</th><th className="text-end">Total</th><th>Project</th><th>Supplier</th></tr></thead>
                            <tbody>
                                {transactions.map((tx) => (
                                    <tr key={tx.id}>
                                        <td>{tx.transaction_date}</td>
                                        <td className="text-capitalize">{tx.type}</td>
                                        <td>{tx.material?.name}</td>
                                        <td>{tx.quantity}</td>
                                        <td className="text-end">{Number(tx.total_cost || 0).toLocaleString()}</td>
                                        <td>{tx.project?.name || '—'}</td>
                                        <td>{tx.supplier?.name || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {tab === 'suppliers' && (
                <div className="card table-card">
                    <div className="table-responsive">
                        <table className="table mb-0">
                            <thead className="table-light"><tr><th>Name</th><th>Contact</th><th>Phone</th><th>Opening</th></tr></thead>
                            <tbody>
                                {suppliers.map((s) => (
                                    <tr key={s.id}>
                                        <td>{s.name}</td>
                                        <td>{s.contact_person || '—'}</td>
                                        <td>{s.phone || '—'}</td>
                                        <td>{Number(s.opening_balance || 0).toLocaleString()} {s.opening_balance_type || ''}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* Modals */}
            {showMat && (
                <div className="modal show d-block app-modal" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={closeMatModal}>
                    <div className="modal-dialog modal-lg">
                        <form className="modal-content" onSubmit={createMaterial}>
                            <div className="modal-header"><h5 className="modal-title">New inventory item</h5><button type="button" className="btn-close" onClick={closeMatModal} /></div>
                            <div className="modal-body row g-2">
                                <div className="col-md-6"><input className="form-control" placeholder="Name" required value={matForm.name} onChange={(e) => setMatForm({ ...matForm, name: e.target.value })} /></div>
                                <div className="col-md-6"><input className="form-control" placeholder="Code" required value={matForm.code} onChange={(e) => setMatForm({ ...matForm, code: e.target.value })} /></div>
                                <div className="col-md-6">
                                    <select className="form-select" value={matForm.category_id} onChange={(e) => onCategoryPick(e.target.value)}>
                                        <option value="">Category</option>
                                        {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-3"><input className="form-control" placeholder="Unit" value={matForm.unit} onChange={(e) => setMatForm({ ...matForm, unit: e.target.value })} /></div>
                                <div className="col-md-3"><input type="number" className="form-control" placeholder="Unit cost" value={matForm.unit_cost} onChange={(e) => setMatForm({ ...matForm, unit_cost: e.target.value })} /></div>
                                <div className="col-md-4"><input type="number" className="form-control" placeholder="Opening stock" value={matForm.current_stock} onChange={(e) => setMatForm({ ...matForm, current_stock: e.target.value })} /></div>
                                <div className="col-md-4"><input type="number" className="form-control" placeholder="Min stock" value={matForm.min_stock} onChange={(e) => setMatForm({ ...matForm, min_stock: e.target.value })} /></div>
                                <div className="col-12"><hr className="my-1" /><small className="text-muted">Account links (optional — defaults from category)</small></div>
                                <div className="col-md-4">
                                    <select className="form-select form-select-sm" value={matForm.inventory_account_id} onChange={(e) => setMatForm({ ...matForm, inventory_account_id: e.target.value })}>
                                        <option value="">Inventory A/C</option>
                                        {accounts.filter((a) => a.type === 'asset').map((a) => <option key={a.id} value={a.id}>{a.code} — {a.name}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <select className="form-select form-select-sm" value={matForm.expense_account_id} onChange={(e) => setMatForm({ ...matForm, expense_account_id: e.target.value })}>
                                        <option value="">Expense A/C</option>
                                        {accounts.filter((a) => a.type === 'expense').map((a) => <option key={a.id} value={a.id}>{a.code} — {a.name}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <select className="form-select form-select-sm" value={matForm.purchase_account_id} onChange={(e) => setMatForm({ ...matForm, purchase_account_id: e.target.value })}>
                                        <option value="">Purchase / Payable A/C</option>
                                        {accounts.filter((a) => a.type === 'liability' || a.type === 'expense').map((a) => <option key={a.id} value={a.id}>{a.code} — {a.name}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="modal-footer"><button type="button" className="btn btn-secondary btn-sm" onClick={closeMatModal}>Cancel</button><button className="btn btn-primary btn-sm">Save</button></div>
                        </form>
                    </div>
                </div>
            )}

            {showCat && (
                <div className="modal show d-block app-modal" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={closeCatModal}>
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <form className="modal-content" onSubmit={createCategory}>
                            <div className="modal-header"><h5 className="modal-title">New category</h5><button type="button" className="btn-close" onClick={closeCatModal} /></div>
                            <div className="modal-body row g-2">
                                <div className="col-8"><input className="form-control" placeholder="Name" required value={catForm.name} onChange={(e) => setCatForm({ ...catForm, name: e.target.value })} /></div>
                                <div className="col-4"><input className="form-control" placeholder="Code" value={catForm.code} onChange={(e) => setCatForm({ ...catForm, code: e.target.value })} /></div>
                                <div className="col-12">
                                    <select className="form-select form-select-sm" value={catForm.inventory_account_id} onChange={(e) => setCatForm({ ...catForm, inventory_account_id: e.target.value })}>
                                        <option value="">Inventory asset account</option>
                                        {accounts.filter((a) => a.type === 'asset').map((a) => <option key={a.id} value={a.id}>{a.code} — {a.name}</option>)}
                                    </select>
                                </div>
                                <div className="col-12">
                                    <select className="form-select form-select-sm" value={catForm.expense_account_id} onChange={(e) => setCatForm({ ...catForm, expense_account_id: e.target.value })}>
                                        <option value="">Expense / COGS account</option>
                                        {accounts.filter((a) => a.type === 'expense').map((a) => <option key={a.id} value={a.id}>{a.code} — {a.name}</option>)}
                                    </select>
                                </div>
                                <div className="col-12">
                                    <select className="form-select form-select-sm" value={catForm.purchase_account_id} onChange={(e) => setCatForm({ ...catForm, purchase_account_id: e.target.value })}>
                                        <option value="">Purchase / Payable account</option>
                                        {accounts.map((a) => <option key={a.id} value={a.id}>{a.code} — {a.name}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="modal-footer"><button type="button" className="btn btn-secondary btn-sm" onClick={closeCatModal}>Cancel</button><button className="btn btn-primary btn-sm">Save</button></div>
                        </form>
                    </div>
                </div>
            )}

            {showTx && (
                <div className="modal show d-block app-modal" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={closeTxModal}>
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <form className="modal-content" onSubmit={createTx}>
                            <div className="modal-header"><h5 className="modal-title">Stock transaction</h5><button type="button" className="btn-close" onClick={closeTxModal} /></div>
                            <div className="modal-body row g-2">
                                <div className="col-12">
                                    <select className="form-select" required value={txForm.material_id} onChange={(e) => setTxForm({ ...txForm, material_id: e.target.value })}>
                                        <option value="">Item</option>
                                        {materials.map((m) => <option key={m.id} value={m.id}>{m.code} — {m.name}</option>)}
                                    </select>
                                </div>
                                <div className="col-6">
                                    <select className="form-select" value={txForm.type} onChange={(e) => setTxForm({ ...txForm, type: e.target.value })}>
                                        <option value="purchase">Purchase</option>
                                        <option value="issue">Issue to site</option>
                                        <option value="return">Return from site</option>
                                        <option value="supplier_return">Return to supplier</option>
                                        <option value="wastage">Wastage</option>
                                        <option value="adjustment">Adjustment</option>
                                    </select>
                                </div>
                                <div className="col-6"><input type="date" className="form-control" value={txForm.transaction_date} onChange={(e) => setTxForm({ ...txForm, transaction_date: e.target.value })} /></div>
                                <div className="col-6"><input type="number" className="form-control" placeholder="Qty" required value={txForm.quantity} onChange={(e) => setTxForm({ ...txForm, quantity: e.target.value })} /></div>
                                <div className="col-6"><input type="number" className="form-control" placeholder="Unit cost" value={txForm.unit_cost} onChange={(e) => setTxForm({ ...txForm, unit_cost: e.target.value })} /></div>
                                <div className="col-6">
                                    <select className="form-select" value={txForm.project_id} onChange={(e) => setTxForm({ ...txForm, project_id: e.target.value })}>
                                        <option value="">Project</option>
                                        {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
                                    </select>
                                </div>
                                <div className="col-6">
                                    <select className="form-select" value={txForm.supplier_id} onChange={(e) => setTxForm({ ...txForm, supplier_id: e.target.value })}>
                                        <option value="">Supplier</option>
                                        {suppliers.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
                                    </select>
                                </div>
                                <div className="col-12 form-check ms-1">
                                    <input className="form-check-input" type="checkbox" id="postAc" checked={txForm.post_to_accounts} onChange={(e) => setTxForm({ ...txForm, post_to_accounts: e.target.checked })} />
                                    <label className="form-check-label" htmlFor="postAc">Post to linked accounts (journal)</label>
                                </div>
                            </div>
                            <div className="modal-footer"><button type="button" className="btn btn-secondary btn-sm" onClick={closeTxModal}>Cancel</button><button className="btn btn-primary btn-sm">Save</button></div>
                        </form>
                    </div>
                </div>
            )}

            {showSup && (
                <div className="modal show d-block app-modal" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={closeSupModal}>
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <form className="modal-content" onSubmit={createSupplier}>
                            <div className="modal-header"><h5 className="modal-title">New supplier</h5><button type="button" className="btn-close" onClick={closeSupModal} /></div>
                            <div className="modal-body row g-2">
                                <div className="col-12"><input className="form-control" placeholder="Name" required value={supForm.name} onChange={(e) => setSupForm({ ...supForm, name: e.target.value })} /></div>
                                <div className="col-6"><input className="form-control" placeholder="Contact person" value={supForm.contact_person} onChange={(e) => setSupForm({ ...supForm, contact_person: e.target.value })} /></div>
                                <div className="col-6"><input className="form-control" placeholder="Phone" value={supForm.phone} onChange={(e) => setSupForm({ ...supForm, phone: e.target.value })} /></div>
                                <div className="col-12"><input className="form-control" placeholder="Address" value={supForm.address} onChange={(e) => setSupForm({ ...supForm, address: e.target.value })} /></div>
                            </div>
                            <div className="modal-footer"><button type="button" className="btn btn-secondary btn-sm" onClick={closeSupModal}>Cancel</button><button className="btn btn-primary btn-sm">Save</button></div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
